import { useTranslation } from 'react-i18next';
import type { StockMode } from '@threadheads/shared';

/** The words for a mode, in the `inventory` namespace (Supply, never "Stock type"). */
export function useSupplyWords(): Record<StockMode, string> {
  const { t } = useTranslation('inventory');
  return {
    stocked: t('baseGarments.supply.stocked'),
    just_in_time: t('baseGarments.supply.justInTime'),
    managed_elsewhere: t('baseGarments.supply.managedElsewhere'),
  };
}
